<template>
  <ion-content>
    <ion-card>
      <ion-card-header>
        <ion-item class="item-no-padding">
          <h1>Bridges</h1>

          <ion-button
            v-if="isAdmin"
            slot="end"
            size="small"
            @click="createBridge"
          >
            <ion-icon :src="i.add" />
          </ion-button>
        </ion-item>
      </ion-card-header>
      <ion-card-content>
        <v-data-table
          :items="bridgeInventory"
          :items-per-page="50"
          :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
          :loading="busy"
          :headers="headers"
        >
          <template v-slot:item.serial_number="{ value, item }">
            {{ value }}
            <ion-badge
              v-if="item.balena_id"
              class="inventory-badge"
            >
              {{ item.balena_id.substring(0, 6) }}
            </ion-badge>

            <ion-icon
              v-if="item.is_virtual"
              class="inventory-badge"
              :src="i.cloudOutline"
            />
          </template>

          <template v-slot:item.region="{ value }">
            {{ region[value] }}
          </template>

          <template v-slot:item.cloud_region="{ value }">
            {{ cloudRegion.get(value) }}
          </template>

          <template v-slot:item.actions="{ item }">
            <ion-button
              v-if="!item.admin_client_id || !item.balena_id"
              :disabled="item.processing"
              @click="process(item)"
            >
              <template v-if="item.processing">
                <ion-spinner />
              </template>
              <template v-else-if="!item.admin_client_id">
                Connect cloud
              </template>
              <template v-else-if="!item.balena_id">
                Connect Balena
              </template>
            </ion-button>

            <ion-button
              :disabled="item.qrLoading"
              @click="showQr(item)"
            >
              <template v-if="item.qrLoading">
                <ion-spinner />
              </template>
              <template v-else>
                QR
              </template>
            </ion-button>

            <ion-button
              v-if="item.is_virtual"
              :href="getAppLinkUrl(item)"
              target="_blank"
            >
              AppLink
            </ion-button>
          </template>
        </v-data-table>
      </ion-card-content>
    </ion-card>
  </ion-content>
</template>

<script>
import Vue from 'vue'

import { mapGetters } from 'vuex'
import { modalController } from '@modus/ionic-vue'

import region from '../../bridge/region'
import cloudRegion from '../../bridge/cloudRegion'

import BridgeQr from './BridgeQr'
import Bridge from './Bridge'
import AvailableBridges from './AvailableBridges'

export default {
  data() {
    return {
      busy: true,
      connectingToCloud: false,
      headers: [
        {
          text: 'Name',
          value: 'serial_number'
        },
        {
          text: 'Region',
          value: 'region'
        },
        {
          text: 'Cloud',
          value: 'cloud_region'
        },
        {
          value: 'actions',
          sortable: false,
          width: '25%'
        }
      ],
      region,
      cloudRegion
    }
  },
  computed: {
    ...mapGetters([
      'bridgeInventory',
      'isAdmin'
    ])
  },
  created() {
    this.fetchBridgeInventory()
  },
  methods: {
    getAppLinkUrl(bridge) {
      return `${process.env.VUE_APP_APP_LINK_URL}/open/setup/${bridge.serial_number}/${bridge.key}`
    },
    fetchBridgeInventory() {
      this.busy = true

      this.$store.dispatch('fetchBridgeInventory')
        .finally(() => this.busy = false)
    },
    process(bridge) {
      let action

      Vue.set(bridge, 'processing', true)

      if(!bridge.admin_client_id) {
        action = 'connectBridgeToCloud'
      }
      else if(!bridge.balena_id) {
        return this.connectToBalena(bridge)
          .finally(() => bridge.processing = false)
      }

      this.$store.dispatch(action, bridge)
        .finally(() => bridge.processing = false)
    },
    async connectToBalena(bridge) {
      const serialNumber = bridge.serial_number

      await this.$store.dispatch('fetchAvailableBalenaBridges', bridge)

      const modal = await modalController
        .create({
          component: AvailableBridges,
          componentProps: {
            propsData: {
              serialNumber
            }
          },
          cssClass: ['card-modal', 'available-bridges-modal']
        })

      modal.present()
    },
    async showQr(bridge) {
      const serialNumber = bridge.serial_number

      Vue.set(bridge, 'qrLoading', true)

      await this.$store.dispatch('fetchBridgeQr', bridge)
        .finally(() => bridge.qrLoading = false)

      const modal = await modalController
        .create({
          component: BridgeQr,
          componentProps: {
            propsData: {
              serialNumber
            }
          },
          cssClass: ['card-modal', 'qr-modal']
        })

      modal.present()
    },
    async createBridge() {
      const modal = await modalController
        .create({
          component: Bridge,
          // componentProps: {
          //   propsData: {
          //     serialNumber
          //   }
          // },
          cssClass: ['card-modal']
        })

      modal.present()
    }
  }
}
</script>

<style>
.inventory-badge {
  vertical-align: middle;
  margin-left:5px;
}
</style>
